import api from "./api/api";
import { toast } from "react-toastify";

const formatQueryValue = (value: any) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join(",");
  }

  return value;
};

const hasQueryValue = (value: any) => {
  if (Array.isArray(value)) return value.length > 0;
  return Boolean(value);
};

export const serviceAreaVendas = {
  getCampanhas: async (
    page: any,
    perPage: any,
    s: any,
    clienteId?: any,
    agenciaId?: any,
    statusId?: any,
    ano?: any,
    mes?: any,
    cidade?: any,
    fluxoId?: any,
  ) => {
    try {
      const params = new URLSearchParams({
        page,
        perPage: !!perPage ? perPage : 5,
      });

      if (s) params.append("s", s);
      if (hasQueryValue(clienteId))
        params.append("clienteId", formatQueryValue(clienteId));
      if (hasQueryValue(agenciaId))
        params.append("agenciaId", formatQueryValue(agenciaId));
      if (hasQueryValue(statusId))
        params.append("statusId", formatQueryValue(statusId));
      if (hasQueryValue(ano)) params.append("ano", formatQueryValue(ano));
      if (hasQueryValue(mes)) params.append("mes", formatQueryValue(mes));
      if (cidade) params.append("cidade", cidade);
      if (hasQueryValue(fluxoId))
        params.append("fluxoId", formatQueryValue(fluxoId));

      const res = await api.get(`/campanhas?${params.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addCampanhas: async (payload: any) => {
    try {
      const res = await api.post("/campanhas", payload);
      return res;
    } catch (error: any) {
      return (
        error?.response ?? {
          status: 500,
          data: {
            error: error?.message,
          },
        }
      );
    }
  },
  editCampanhas: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/campanhas/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error: any) {
      return (
        error?.response ?? {
          status: 500,
          data: {
            error: error?.message,
          },
        }
      );
    }
  },
  DeleteCampanhas: async (id: any) => {
    try {
      const res = await api.delete(`/campanhas/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
};
